var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _circle, _circle2, _circle3, _circle4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgWrongIcon = function SvgWrongIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 154 154",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M154 80c0 40.869-33.131 74-74 74-40.87 0-74-33.131-74-74C6 39.13 39.13 6 80 6c40.869 0 74 33.13 74 74Z",
    fill: "#F7F9FC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m135 46-30-32v28a4 4 0 0 0 4 4h26Z",
    fill: "#E4E9ED"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33 141a4 4 0 0 0 4 4h94a4 4 0 0 0 4-4V46h-26a4 4 0 0 1-4-4V14h-9l-7.623 14.292a1 1 0 0 0 .232 1.23l5.766 4.942a1 1 0 0 1 .219 1.252L78.374 64.34c-.101.179-.374.107-.374-.099V42.535a1 1 0 0 0-.445-.832l-10.969-7.312a1 1 0 0 1-.415-1.075L71 14H37a4 4 0 0 0-4 4v123Z",
    fill: "#FBFCFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M135 46h.5v-.198l-.135-.144L135 46Zm-30-32 .365-.342-.148-.158H105v.5Zm-34 0 .485.121.155-.621H71v.5Zm25 0v-.5h-.3l-.141.265L96 14Zm-1.406 21.716.435.247-.435-.247Zm-.22-1.252-.325.38.326-.38Zm-16 29.876.435.246-.435-.246Zm-.82-22.637-.277.416.278-.416Zm-11.383-8.387-.485-.12.485.12Zm.415 1.075.278-.416-.278.416Zm22.023-4.869.325-.38-.325.38Zm-.231-1.23-.442-.235.441.235ZM131 144.5H37v1h94v-1ZM33.5 141V18h-1v123h1Zm101-95v95h1V46h-1Zm.865-.342-30-32-.73.684 30 32 .73-.684ZM109 46.5h26v-1h-26v1ZM104.5 14v28h1V14h-1Zm-67.5.5h34v-1H37v1Zm33.515-.621-4.83 19.316.971.243 4.83-19.317-.971-.242Zm-4.206 20.928 10.968 7.312.555-.832-10.968-7.312-.555.832ZM77.5 42.535v21.706h1V42.535h-1Zm1.309 22.052 16.22-28.624-.87-.493-16.22 28.624.87.493ZM94.7 34.084l-5.766-4.942-.65.76 5.765 4.942.651-.76Zm-5.881-5.557 7.622-14.292-.882-.47-7.623 14.292.883.47ZM96 14.5h9v-1h-9v1Zm-.97 21.463a1.5 1.5 0 0 0-.33-1.879l-.65.76a.5.5 0 0 1 .109.626l.87.493ZM77.5 64.24c0 .72.954.971 1.309.346l-.87-.493c.152-.269.561-.16.561.147h-1Zm-.223-22.122a.5.5 0 0 1 .223.416h1a1.5 1.5 0 0 0-.668-1.248l-.555.832Zm-11.591-8.924a1.5 1.5 0 0 0 .623 1.612l.555-.832a.5.5 0 0 1-.208-.537l-.97-.243ZM37 144.5a3.5 3.5 0 0 1-3.5-3.5h-1a4.5 4.5 0 0 0 4.5 4.5v-1Zm94 1a4.5 4.5 0 0 0 4.5-4.5h-1a3.5 3.5 0 0 1-3.5 3.5v1Zm-22-100a3.5 3.5 0 0 1-3.5-3.5h-1a4.5 4.5 0 0 0 4.5 4.5v-1ZM88.934 29.142a.5.5 0 0 1-.115-.614l-.883-.471a1.5 1.5 0 0 0 .348 1.845l.65-.76ZM33.5 18a3.5 3.5 0 0 1 3.5-3.5v-1a4.5 4.5 0 0 0-4.5 4.5h1Z",
    fill: "#E4E9ED"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M62.66 107.875a1.75 1.75 0 1 0 2.68 2.25l-2.68-2.25Zm39 2.25a1.75 1.75 0 1 0 2.68-2.25l-2.68 2.25ZM64 109l1.34 1.126-.001.001-.001.001a.21.21 0 0 0 .008-.009l.046-.053a18.373 18.373 0 0 1 1.104-1.109c.8-.739 1.996-1.735 3.558-2.732 3.126-1.995 7.678-3.975 13.446-3.975v-3.5c-6.598 0-11.796 2.27-15.329 4.525a28.952 28.952 0 0 0-4.051 3.112c-.463.428-.818.788-1.062 1.047a14.443 14.443 0 0 0-.362.398l-.024.028a.078.078 0 0 0-.007.009l-.003.003-.001.002S62.66 107.875 64 109Zm19.5-6.75c5.768 0 10.32 1.98 13.446 3.975a25.431 25.431 0 0 1 3.558 2.732 18.36 18.36 0 0 1 1.104 1.109l.046.053.008.009-.001-.001-.001-.001L103 109c1.34-1.125 1.34-1.126 1.339-1.126l-.001-.002-.003-.003-.007-.009-.024-.028a14.346 14.346 0 0 0-.362-.398 21.777 21.777 0 0 0-1.062-1.047 28.946 28.946 0 0 0-4.051-3.112c-3.533-2.255-8.731-4.525-15.329-4.525v3.5Z",
    fill: "#F1928D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.875 30.5H48a1.5 1.5 0 0 0 0 3h18.143c.003-.061.013-.123.028-.184l.704-2.816Z",
    fill: "#E4E9ED"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m64 73 10 10m-10 0 10-10M93 73l10 10m-10 0 10-10",
    stroke: "#F1928D",
    strokeWidth: 3.5,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5 42.5h17",
    stroke: "#E4E9ED",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 147,
    cy: 25,
    r: 6,
    fill: "#F5FAFA"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 116,
    cy: 4,
    r: 4,
    fill: "#F5FAFA"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 27,
    r: 4,
    fill: "#F5FAFA"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 133,
    r: 8,
    fill: "#F5FAFA"
  })));
};

export { SvgWrongIcon as ReactComponent };
export default __webpack_public_path__ + "static/media/wrong-icon.d52c1fb9.svg";